<template>
   <div class='Publicadas'>
    
    <div v-if="loading">
        <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>  
    <div v-else>
        <div v-if="projectos == null">
            <div class="row pt-3">
                <div class="col">
                    <div class="card">
                        <p class="text-center pt-2">Sin Proyectos</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <!-- Tabla -->
            <table class="table">
            <thead>
                <tr>
                    <th scope="col">Nombre Proyecto</th>
                    <th scope="col">Propuestas</th>
                    <th scope="col" class="text-center">Fecha Creación</th>
                    <th scope="col" class="text-center">Fecha Inicio</th>
                    <th scope="col" class="text-center">Fecha Entrega</th>
                    <th scope="col">Concesión</th>
                    <th scope="col" class="text-center">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="f in projectos" :key="f.id">
                    <td>
                        <router-link :to="{ name: 'DetalleProyecto', params: { idEmpresa: f.id_proyecto}}"> 
                            {{f.titulo_proyecto}} 
                            <span v-if="f.asignadaA != 0">
                                <small class="text-success">(Adjudicado)</small>
                            </span>
                        </router-link>
                        <span v-if="f.nuevo_comentario > 0" style="color:#fd7e14">
                            <font-icon icon="blog"/>
                            {{f.nuevo_comentario}}
                        </span>
                        <span v-else>
                            <font-icon icon="blog"/>
                        </span>
                    </td>
                    
                    <!--PROPUESTAS-->
                    <td>
                        <router-link class="btn btn-sm btn-dark" :to="{ name: 'Propuestas', params: { idEmpresa: f.id_proyecto, nombre: f.titulo_proyecto}}"> 
                            <font-icon icon="file-invoice-dollar" style="font-size:20px"></font-icon> Ver Propuestas
                            <span class="badge badge-warning">{{f.total}}</span>
                        </router-link>
                    </td>
                    
                    <td>
                        <p class="text-center">
                           {{fechaFormat(f.fecha)}}
                        </p> 
                    </td>
                    <td>
                        <p class="text-center">
                           {{fechaFormat(f.fecha_inicio)}}
                        </p>
                    <td>
                        <p class="text-center">
                            {{fechaFormat(f.fecha_cierre)}} <br>
                            <span class="text-warning" v-if="f.fecha_valida < 5 && f.fecha_valida > 0">
                                Por Vencer
                            </span>
                             <span class="text-danger" v-if="f.fecha_valida < 0">
                                Vencida
                            </span>
                        </p>
                    </td>
                    <td>
                        <button class="btn btn-sm btn-warning" 
                                data-toggle="modal" 
                                data-target='#modalExtender'
                                @click="fetchID(f)"
                        >
                            Extender entrega
                        </button>
                    </td>
                    <!--PAUSAR & CANCELAR-->
                    <td class="text-center">
                        <button class="btn btn-sm btn-danger" 
                                     @click="openModal(f)"
                                     data-toggle="tooltip" 
                                     data-placement="top" 
                                     title="Cancelar Proyecto"
                                     >
                            <font-icon icon="times"/>
                        </button>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>


<!--Modal Extender Entrega -->
<div class="modal fade" id="modalExtender" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">Extender fecha de entrega del proyecto:</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form @submit="cambiarFecha">
            <div class="modal-body">
                <h3 class="text-center">{{nombreProyecto}}</h3>
                <hr>
                <label for="">Fecha Actual</label>
                <input type="date" class="form-control" v-model="fechaAnterior" disabled>
                <br>
                <label for="">Nueva Fecha</label>
                <input type="date" class="form-control" v-model="newFecha" required>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                <button type="submit" class="btn orange"> Cambiar </button>
            </div>
        </form>
        </div>
    </div>
</div>

<!--Modal Cancelar -->
<div class="modal fade" id="modalCancelar" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">Cancelación del Proyecto:</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form @submit="borrar">
            <div class="modal-body">
                <div>
                    <h3 class="text-center">{{nombreProyecto}}</h3>
                    <textarea class="form-control" v-model="razonCancelacion" rows="5" required maxlength="100"
                    placeholder="Razon por cancelacion..."></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                <button type="submit" class="btn orange"> Aceptar </button>
            </div>
        </form>
        </div>
    </div>
</div>

    
   </div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

export default {
name: 'Publicadas',
mixins: [ globalFunctions ],
data () {
    return {
        projectos: [],
        loading: true,
        activeID: '',
        newFecha: '',
        fechaAnterior: '',
        razonCancelacion: '',
        nombreProyecto: '',
    }
},
methods: {
    getData(){
        let data = {
            id: localStorage.userID,
            prop: 2,
            flag:0,
        };

        this.axios.post(this.url + 'getProyectos.php',data).then((responce) =>{
            this.projectos = responce.data;
            this.loading = false;
            this.$emit("update");
        });
    },

    fetchID(f){
        this.activeID = f.id_proyecto;
        this.fechaAnterior = f.fecha_cierre;
        this.nombreProyecto = f.titulo_proyecto;
    },

    openModal(f){
        $('#modalCancelar').modal('show');
        this.fetchID(f);
    },

    cambiarFecha(e){
        e.preventDefault();

        if(this.newFecha <= this.fechaAnterior){
            this.msjError("Nueva Fecha debe ser mayor a fecha anterior");
            return;
        }
         let data = {
            flag:9,
            id:this.activeID,
            nuevaFecha: this.newFecha
        };

        this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
            if(responce.data == 200){
                this.msjOk("Fecha Actualizada");
                this.nuevaFecha = '';
                $('#modalExtender').modal('hide');
                this.getData();
                this.$emit("update");
            }
        });
    },
    
    borrar(e){
        e.preventDefault();
        
        this.$swal.fire({
            title: '¿Estas Seguro?',
            text: "Ya no podras revertir el cambio",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, cancelar proyecto'
            }).then((result) => {
                if (result.isConfirmed) {
                
                    let data = {
                        flag:0,
                        num: 7, //status
                        id: this.activeID,
                        razon: this.razonCancelacion
                    };
                    
                    this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
                        if(responce.data == 200){
                            $('#modalCancelar').modal('hide');
                            this.getData();
                            this.$swal.fire(
                             'Cancelado',
                             'Tu proyecto ha sido cancelado.',
                             'success'
                            );
                        }
                    });
                }
            })
    },
},
computed:{
    ...mapState(['url'])
},
mounted(){
    this.getData();
}
}
</script>


<style scoped>
.table{
    background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/views/Proyectos/components/Empresa/Publicadas.vue